'use client'

// src/LoadingMessages/LoadingMessages.tsx
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { jsx } from "react/jsx-runtime";
var defaultMessages = [
  "Creating Magical Connection \u2728",
  "Checking Cosmic Availability \u{1F680}",
  "Polishing Adventure Choices \u2728",
  "Scoring Stellar Deals Just for You \u{1F31F}",
  "Dancing with Secure Systems \u{1F483}\u{1F57A}",
  "Crafting Your One-of-a-Kind Itinerary \u{1F5FA}\uFE0F",
  "Prepping for a Seamlessly Epic Journey \u{1F308}",
  "Summoning Dreamy Experiences \u2728",
  "Exploring Galactic Options \u{1F30C}",
  "Crafting Joyful Moments \u{1F3A8}",
  "Gathering Starlight Surprises \u{1F320}",
  "Weaving Wonder Tales \u{1F4DA}",
  "Painting Rainbow Escapes \u{1F308}",
  "Spinning Enchanted Tales \u{1F9DA}",
  "Charting New Journeys \u{1F5FA}\uFE0F",
  "Unfolding Fantasy Worlds \u{1F3F0}",
  "Mixing Magic Potions \u{1F9EA}",
  "Prepping your journey in the clouds \u{1F325}\uFE0F",
  "Fasten your seatbelts \u{1F4BA}",
  "Plotting your route to the skies \u{1F320}",
  "Clearing for takeoff \u{1F6EB}"
];
var LoadingMessages = ({ messages = defaultMessages }) => {
  const [messageIndex, setMessageIndex] = useState(-1);
  useEffect(() => {
    const interval = setInterval(() => {
      let nextIndex;
      do {
        nextIndex = Math.floor(Math.random() * messages.length);
      } while (nextIndex === messageIndex);
      setMessageIndex(nextIndex);
    }, 2e3);
    return () => clearInterval(interval);
  }, [messageIndex, messages.length]);
  return /* @__PURE__ */ jsx(AnimatePresence, { mode: "wait", children: !!messages[messageIndex] && /* @__PURE__ */ jsx(
    motion.div,
    {
      initial: { opacity: 0 },
      animate: { opacity: 0.5 },
      exit: { opacity: 0 },
      transition: { duration: 0.15 },
      className: "p-2 text-center text-sm",
      children: messages[messageIndex]
    },
    messages[messageIndex]
  ) });
};
var LoadingMessages_default = LoadingMessages;

export {
  LoadingMessages_default
};
//# sourceMappingURL=chunk-YAOCNNXI.mjs.map